// DiagiaDocPage — view a saved diagnostic by its id.
//
// Reuses the polished DiagnosticDoc renderer so the formatting matches the
// "live" generation experience the user just had.

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';

import DiagnosticDoc from '../../diagnostic/DiagnosticDoc';
import useDiagiaApi from '../hooks/useDiagiaApi';

export default function DiagiaDocPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const api = useDiagiaApi();

  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.getMyDiagnostic(id)
      .then((d) => { if (!cancelled) setDoc(d); })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.response?.status === 404
            ? 'Diagnostic introuvable'
            : 'Erreur de chargement');
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [api, id]);

  if (loading) {
    return (
      <div className="dia-loading">
        <FaSpinner className="dia-spin" /> Chargement…
      </div>
    );
  }

  if (error) {
    return <p className="dia-error">{error}</p>;
  }

  if (!doc) return null;

  return (
    <DiagnosticDoc
      markdown={doc.markdown}
      onBack={() => navigate('/diagia/diagnostics')}
      onRestart={() => navigate('/diagia/new')}
    />
  );
}
